import React from "react";
import styles from "./styles.module.scss";
import { FaAngleLeft } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa6";
import { Button } from "rsuite";

const Pagination = ({
  nextPage,
  prevPage,
  count,
  setCount,
  totalProducts,
  limit,
}: {
  nextPage: () => void;
  prevPage: () => void;
  count: number;
  setCount: (count: number) => void;
  totalProducts: number;
  limit: number;
}) => {
  return (
    <div className={styles.root}>
      <Button
        className={styles.left}
        disabled={count === 1}
        onClick={() => {
          prevPage();
          setCount(count - 1);
        }}
      >
        <FaAngleLeft />
      </Button>
      <span className={styles.count}>{count}</span>
      <Button
        className={styles.right}
        disabled={count === Math.ceil(totalProducts / limit)}
        onClick={() => {
          nextPage();
          setCount(count + 1);
        }}
      >
        <FaAngleRight />
      </Button>
    </div>
  );
};

export default Pagination;
